import React, { ReactNode } from 'react'

export function Alert({content, className = "alert-danger", onDismiss}:{content:ReactNode, className?:string, onDismiss?:()=>void}){
    return <div className={`alert d-flex justify-content-between mt-3 ${className}`}>
        <div>{content}</div>
        {onDismiss != null && <button type="button" className="btn-close default-color" onClick={() => onDismiss()} aria-label="Close"></button>}
    </div>
}